<script>
import moment from 'moment'

export default {
	props: {
		targetDate: {
			type: [String, Number, Date],
			required: true,
		},
	},
	data() {
		return {
			nowMs: Date.now(),
			intervalId: null,
		}
	},
	computed: {
		targetMs() {
			const parsed = moment(this.targetDate).valueOf()
			return Number.isNaN(parsed) ? 0 : parsed
		},
		remainingMs() {
			return Math.max(this.targetMs - this.nowMs, 0)
		},
		parts() {
			const totalSeconds = Math.floor(this.remainingMs / 1000)
			const seconds = totalSeconds % 60
			const totalMinutes = Math.floor(totalSeconds / 60)
			const minutes = totalMinutes % 60
			const totalHours = Math.floor(totalMinutes / 60)
			const hours = totalHours % 24
			const days = Math.floor(totalHours / 24)
			return { days, hours, minutes, seconds }
		},
		countdownText() {
			const { days, hours, minutes, seconds } = this.parts
			return `${days}d ${hours}h ${minutes}m ${seconds}s`
		},
	},
	mounted() {
		this.intervalId = setInterval(() => {
			this.nowMs = Date.now()
		}, 1000)
	},
	beforeDestroy() {
		if (this.intervalId) {
			clearInterval(this.intervalId)
			this.intervalId = null
		}
	},
}
</script>

<template>
	<span>{{ countdownText }}</span>
</template>

